module.exports = __webpack_public_path__ + "img/lx_website_logo.735a6cb3.png";